import axios from 'axios';
import { ApiResponseType } from '../../types/types';
import {
  GetEarningByTypeAndIdResponse,
  GetEarningsHistoryResponse,
  GetEarningsInfoForUserResponse
} from './Earnings.types';

export const getEarningsInfoAsync = async (): Promise<
  ApiResponseType<GetEarningsInfoForUserResponse>
> => {
  const { data } = await axios.get<
    ApiResponseType<GetEarningsInfoForUserResponse>
  >(`/user/earnings/info`);
  return data;
};

export const getEarningHistoryAsync = async ({
  id,
  sortBy,
  sortOrder,
  fromDate,
  toDate,
  status,
  numberOfPage,
  countPerPage,
  earningsTypes
}: any): Promise<ApiResponseType<GetEarningsHistoryResponse>> => {
  const { data } = await axios.get<ApiResponseType<GetEarningsHistoryResponse>>(
    `/user/earnings/history`,
    {
      params: {
        sortBy,
        sortOrder,
        numberOfPage,
        countPerPage,
        id: id ? id : null,
        status: status ? status : null,
        fromDate: fromDate && toDate ? fromDate : null,
        toDate: fromDate && toDate ? toDate : null,
        earningsTypes
      }
    }
  );
  return data;
};

export const getEarningDetailsAsync = async (
  type: number,
  id: number
): Promise<ApiResponseType<GetEarningByTypeAndIdResponse>> => {
  const { data } = await axios.get<
    ApiResponseType<GetEarningByTypeAndIdResponse>
  >(`/user/earnings/type/${type}/id/${id}`);

  return data;
};
